import React from 'react';
import {Trans} from '@deviceinsight/ng-ui-scale-lib/api';
import {Button, Icon} from '@deviceinsight/ng-ui-basic-components';
import {AssetWithMetaData} from '../types';
type Props = {
	selectedDevice: AssetWithMetaData | null | undefined;
	onRemoveClicked: () => void;
};

const SelectedDeviceInfo = ({selectedDevice, onRemoveClicked}: Props) => {
	if (selectedDevice) {
		const {
			asset: {name, urn}
		} = selectedDevice;
		return (
			<div className="selected-device-info active">
				<label>
					{urn ? (
						name
					) : (
						<Trans i18nKey="dashboard.widgets.floorplan.assetnotingroup">
							Asset is not a member of this group (anymore) - please remove it from the floorplan
						</Trans>
					)}
				</label>
				<label>{selectedDevice.asset.urn}</label>
				<Button naked onClick={onRemoveClicked}>
					<Icon del />
					<Trans i18nKey="dashboard.widgets.floorplan.removeasset">Remove from floorplan</Trans>
				</Button>
			</div>
		);
	} else {
		return <div className="selected-device-info" />;
	}
};

export default SelectedDeviceInfo;
